export const RIDE_LOCATION_MIN_QUERY_LENGTH = 3;
export const RIDE_LOCATION_SEARCH_DEBOUNCE_MS = 700;
export const RIDE_LOCATION_REVERSE_DEBOUNCE_MS = 700;
